import { apiFetch } from "@hp/api-client";
import type { AgreementClauseDetail } from "./types";

/**
 * Fetch one AgreementClause together with the CompanyAgreement it belongs
 * to. Wrap in `useQuery` with a queryKey of `["agreement-clauses", id]`.
 */
export async function getAgreementClause(id: string, signal?: AbortSignal): Promise<AgreementClauseDetail> {
  return apiFetch<AgreementClauseDetail>(`/agreement-clauses/${encodeURIComponent(id)}`, {
    method: "GET",
    signal,
  });
}
